"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPolicyManagementPath = exports.isSMPath = exports.isSlack = void 0;

var isSlack = function isSlack(medium) {
  return (medium === null || medium === void 0 ? void 0 : medium.toLowerCase()) === 'slack';
};

exports.isSlack = isSlack;

var isSMPath = function isSMPath() {
  return location.pathname.includes('/secret-manager');
};

exports.isSMPath = isSMPath;

var isPolicyManagementPath = function isPolicyManagementPath() {
  return location.pathname.includes('/policy-management');
};

exports.isPolicyManagementPath = isPolicyManagementPath;